import { CatalogueService } from 'src/app/angularJS/services/catalogue/catalogue.service';

export class ProductCatalogueNotificationsController {
  public static $inject = ['$rootScope', '$stateParams', 'catalogueService'];
  public notifications: Array<InterACT.Interfaces.Catalogues.Notification>;

  constructor(private $rootScope, private $stateParams, private catalogueService: CatalogueService) {
    this.activate();
  }

  private activate() {
    this.$rootScope.showSpinner = true;
    const options = {
      includeValidation: true,
      catalogueVersion: this.$stateParams.catalogueVersion
    };
    return this.catalogueService.getCatalogue(this.$stateParams.catalogueId, options).then((response: InterACT.Interfaces.Catalogues.CatalogueResponse) => {
      this.notifications = response.notifications;
      this.$rootScope.showSpinner = false;
    });
  }
}